module.exports = __webpack_public_path__ + "files/SPIADI2019 - Poster ECCMID.3a5ae11f3f8d248fc7c97e7cd3a1c0f1.pdf";